import React, { useState } from "react";
import { FiSend, FiMail, FiMapPin, FiClock } from "react-icons/fi";
import Frame from "../layout/Frame";
import Meta from "../layout/Meta";
import brand from "../db/brand";

const Contact = () => {
  const [sent, setSent] = useState(false);
  const [form, setForm] = useState({ name: "", company: "", email: "", spend: "<€50k/mo", message: "" });
  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = (e) => { e.preventDefault(); setSent(true); };

  return (
    <Frame>
      <Meta title="Contact" description={`Reach ${brand.short} — performance advertising studio based in ${brand.hq.city}.`} />
      <section className="svc-hero">
        <div className="shell">
          <div className="crumb"><a href="/">Home</a><span className="sep">/</span>Contact</div>
          <span className="tag tag--orange">BRIEF US</span>
          <h1 style={{ marginTop: "1.25rem" }}>Send the spend, the metric, the timeline.</h1>
          <p className="lede">
            We respond within one business day with what we think we can verifiably move — and how we would
            structure the test. Including referring you elsewhere if we are not the fit.
          </p>
        </div>
      </section>
      <section className="band">
        <div className="shell">
          <div className="dispatch">
            <div className="dispatch-info">
              <span className="tag">DIRECT CHANNELS</span>
              <h2 style={{ fontSize: "1.9rem", marginTop: "1.25rem" }}>The fastest paths in.</h2>
              <p style={{ color: "#6b6b6b", marginBottom: "2rem" }}>
                For most enquiries the form on the right is quickest. The channels below also land directly with the senior team.
              </p>
              <div className="block">
                <div className="lbl"><FiMail style={{ marginRight: 6 }} /> E-MAIL</div>
                <a className="val" href={`mailto:${brand.contact.email}`}>{brand.contact.email}</a>
              </div>
              <div className="block">
                <div className="lbl"><FiMapPin style={{ marginRight: 6 }} /> OFFICE</div>
                <div className="val" style={{ lineHeight: 1.45 }}>
                  {brand.hq.address.line1}<br />
                  {brand.hq.address.line2}
                </div>
              </div>
              <div className="block">
                <div className="lbl"><FiClock style={{ marginRight: 6 }} /> HOURS</div>
                <div className="val">{brand.contact.hours}</div>
              </div>
            </div>
            <div className="dispatch-form">
              {sent ? (
                <div style={{ textAlign: "center", padding: "2rem 0" }}>
                  <h3>Brief received.</h3>
                  <p style={{ color: "rgba(255,255,255,.7)" }}>A senior team member will reply within one business day.</p>
                </div>
              ) : (
                <form onSubmit={submit}>
                  <h3>Send a brief.</h3>
                  <p style={{ color: "rgba(255,255,255,.6)", fontSize: ".95rem", margin: "0 0 1.5rem" }}>
                    A few honest lines is enough. Spend, target metric, market.
                  </p>
                  <div className="field-row">
                    <div className="field">
                      <label>Name</label>
                      <input required value={form.name} onChange={update("name")} placeholder="Jane Doe" />
                    </div>
                    <div className="field">
                      <label>Company</label>
                      <input value={form.company} onChange={update("company")} placeholder="Company" />
                    </div>
                  </div>
                  <div className="field">
                    <label>Email</label>
                    <input required type="email" value={form.email} onChange={update("email")} placeholder="you@brand.com" />
                  </div>
                  <div className="field">
                    <label>Current monthly spend</label>
                    <select value={form.spend} onChange={update("spend")}>
                      <option>&lt;€50k/mo</option><option>€50k — €150k/mo</option>
                      <option>€150k — €500k/mo</option><option>€500k+/mo</option>
                      <option>Not yet — pre-launch</option>
                    </select>
                  </div>
                  <div className="field">
                    <label>Brief</label>
                    <textarea required value={form.message} onChange={update("message")}
                      placeholder="What's the spend mix, what metric should move, what's the timeline?" />
                  </div>
                  <button type="submit" className="btn btn--orange">Send brief <FiSend /></button>
                  <div className="note">
                    By submitting you agree {brand.short} may contact you about your enquiry.
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
    </Frame>
  );
};

export default Contact;
